import { DecorativeRow } from "./DecorativeRow";

// Shared page header: top decorative row, <h1><span class="tagline">…</span></h1>,
// an optional subtitle paragraph, and a bottom decorative row.
//
// Each caller passes its own wrapper className (menu-header, catering-header,
// home-header, etc.) because those classes each have page-specific layout
// overrides (padding, max-width, position). The inner structure is identical.
export const PageHeader = ({
  className,
  tagline,
  subtitle,
  subtitleClassName = "subtitle",
}) => (
  <div className={className}>
    <DecorativeRow />
    <h1>
      <span className="tagline">{tagline}</span>
    </h1>
    {subtitle && <p className={subtitleClassName}>{subtitle}</p>}
    <DecorativeRow position="bottom" />
  </div>
);
